
  import React from "react"
  import Component from "/home/ws/spaceland/modebewusst.bundfuerbildung.de/src/layouts/index.js"
  import data from "/home/ws/spaceland/modebewusst.bundfuerbildung.de/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js